import axiosInstance from "../axiosClient";
import { addLanguage, languagesList, updateLanguageDetail } from "../config";

export const getLanguages = async (name,limit,start_key) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${languagesList}${queryString}`);
};

export const createLanguage =  async(data) => {
  return await axiosInstance.post(addLanguage,data);
};

export const updateLanguageDetails= async (data) => {
  return await axiosInstance.put(updateLanguageDetail, data);
};
